import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
    return (
        <section
            className="grid min-h-[calc(100vh-72px)] place-items-center bg-brand-offwhite"
            data-testid="not-found-page"
        >
            <div className="container-x text-center">
                <p className="font-mono-tag text-brand-gold">[ 404 ]</p>
                <h1 className="mt-6 font-display text-7xl leading-[1.1] md:text-9xl">
                    PAGE NOT FOUND
                </h1>
                <p className="mx-auto mt-6 max-w-md font-body text-brand-steel">
                    That page has been demolished. Head back to the site.
                </p>
                <Link
                    to="/"
                    className="mt-10 inline-flex items-center gap-2 border border-brand-charcoal px-6 py-3 font-mono text-xs uppercase tracking-[0.25em] text-brand-charcoal transition-colors hover:bg-brand-charcoal hover:text-brand-offwhite"
                    data-testid="not-found-home"
                >
                    <ArrowLeft className="h-4 w-4" /> Back to Home
                </Link>
            </div>
        </section>
    );
}
